"use strict";

exports.__esModule = true;
var _ImageCard = _interopRequireDefault(require("./ImageCard"));
exports.default = _ImageCard.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}